import { Component, inject, input, OnDestroy, OnInit, output } from '@angular/core';
import { RidSentenceReadingBase } from '../../components/rid-sentence-reading-base/rid-sentence-reading-base';
import { RidSentence } from '../../components/rid-sentence/rid-sentence';
import { ExpressionService } from '../../services/expression-service.service';

@Component({
  selector: 'rid-sentence-reading-guided',
  imports: [RidSentenceReadingBase],
  templateUrl: './rid-sentence-reading-guided.html',
  host: {
    class: 'block',
  },
})
export class RidSentenceReadingGuided implements OnInit, OnDestroy {
  private readonly $expressionService = inject(ExpressionService);

  sentencesMatrix = input.required<string[][]>();
  pace = input.required<number>();
  mode = input.required<'WORD' | 'KLANK'>();

  finished = output<void>();

  ngOnInit(): void {
    this.$expressionService.setAvailability('CLIENT', true);
  }

  ngOnDestroy(): void {
    this.$expressionService.setAvailability('CLIENT', false);
  }

  async doSentencePass(sentence: RidSentence, pace: number): Promise<void> {
    await sentence.pass(pace, { opacity: 0.5, scale: 0.8 }, { opacity: 1, scale: 1 }, this.mode());
  }
}
